module.exports = __webpack_public_path__ + "static/img/testimony (19).91bcb39a.jpg";